import { ActionType, createReducer } from 'typesafe-actions';
import { loyaltyMembersActions } from './actions';
import { LoyaltyMembersState } from './types';

export const loyaltyMembersInitialState = {
  loading: false,
  data: [],
  error: null,
  initial: true,
  locking: false,
  lockRequested: false,
  searchPayload: ''
};

export const loyaltyMembersReducer = createReducer<LoyaltyMembersState, ActionType<typeof loyaltyMembersActions>>(
  loyaltyMembersInitialState
)
  .handleAction(loyaltyMembersActions.fetchLoyaltyMembers.request, state => ({
    ...state,
    loading: true,
    error: null
  }))
  .handleAction(loyaltyMembersActions.fetchLoyaltyMembers.success, (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
    error: null,
    initial: false
  }))
  .handleAction(loyaltyMembersActions.fetchLoyaltyMembers.failure, (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    initial: false
  }))
  .handleAction(loyaltyMembersActions.resetLoyaltyMembersStore, () => ({
    ...loyaltyMembersInitialState
  }))
  .handleAction(loyaltyMembersActions.saveLoyaltyMembersPayload, (state, { payload }) => ({
    ...state,
    searchPayload: payload
  }))
  .handleAction(loyaltyMembersActions.lockLoyaltyMember.request, state => ({
    ...state,
    locking: true
  }))
  .handleAction(loyaltyMembersActions.lockLoyaltyMember.success, (state, { payload }) => ({
    ...state,
    data: state.data.map(item =>
      item.account !== payload ? item : { ...item, status: item.status === 'ACTIVE' ? 'FROZEN' : 'ACTIVE' }
    ),
    locking: false,
    lockRequested: true
  }))
  .handleAction(loyaltyMembersActions.lockLoyaltyMember.failure, state => ({
    ...state,
    locking: false
  }))
  .handleAction(loyaltyMembersActions.resetLockRequested, state => ({
    ...state,
    lockRequested: false
  }));
